<template>
  <BaseMultistep
    :steps="Step"
    :initial-step="startingStep"
    wizard-id="reg"
    @step-change="updateCurrentStep"
  >
    <template #[Step.SELECT_ROLE]="{ changeStep }">
      <div class="buttons">
        <BaseButton
          size="lg"
          @click="() => changeStep(Step.REGISTER_CUSTOMER)"
        >
          Customer
        </BaseButton>
        <BaseButton
          size="lg"
          temperature="cool"
          @click="() => changeStep(Step.REGISTER_SELLER)"
        >
          Seller
        </BaseButton>
      </div>
    </template>
    <template #[Step.REGISTER_CUSTOMER]="{ changeStep }">
      <RegisterForm
        ref="registerForm"
        :as-seller="false"
        :loading-state="loadingState"
        @finish="() => router.push({ name:'onboard'})"
      />
    </template>
    <template #[Step.REGISTER_SELLER]="{ changeStep }">
      <RegisterForm
        ref="registerForm"
        :as-seller="true"
        :loading-state="loadingState"
        @finish="() => router.push({ name:'onboard'})"
      />
    </template>
  </BaseMultistep>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useCurrentStep } from '~/composables/states/current-step';
import { registrationStep } from '~/common/step';
import { LoadingState } from '~/composables/states/loading-state';
import RegisterForm from '~/components/form/register/RegisterForm.vue';

const props = withDefaults(defineProps<{
  startingStep?:(typeof registrationStep)[keyof typeof registrationStep],
  loadingState?: LoadingState
}>(), {
  startingStep: registrationStep.SELECT_ROLE,
  loadingState: undefined,
});

const router = useRouter();

const registerForm = ref<typeof RegisterForm>();

const Step = registrationStep;

const emit = defineEmits(['loading', 'unload']);

const {
  currentStep,
  updateCurrentStep,
} = useCurrentStep();
updateCurrentStep(props.startingStep);

defineExpose({
  currentStep,
});
</script>

<style scoped lang="scss">
.buttons {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);

  button {
    width: 100%;
    text-align: center;
  }
}

</style>
